import { isLocalhostInSafari } from "@blofin/blofin-utils/func/helper";
import { ResponseGatewayPlugin } from "../../../type";
import Cookies from "js-cookie";

const setResponseTokenPlugin: ResponseGatewayPlugin = {
  name: "setResponseTokenPlugin",
  type: "response",
  apply(res, options) {
    const token = Cookies.get("token");
    if (token) {
      Cookies.set("token", token, {
        sameSite: "none",
        secure: isLocalhostInSafari() ? false : true,
        expires: 999,
      });
    }
    return res;
  },
};

export default setResponseTokenPlugin;
